import React from "react";
import SubpageTitle from "../components/subpageTitle";
import phoneLogo from "../images/phone.svg"
import emailLogo from "../images/email.svg"
import Footer from "../components/footer"


function Contact() {
    return(
        <div>
            <SubpageTitle title="Contact Us"/>
            <div>
                <div>
                    <div id='contactInfo' className="flex flex-col md:flex-row justify-center center-items md:p-40">
                        <div className="flex flex-1 flex-col items-center md:p-0 py-10">
                            <img className="w-10" src={phoneLogo} alt="Phone"/>
                            <p className="text-3xl font-semibold">Give Us a Call:</p>
                            <p className="text-lg">1-877-685-2496</p>
                        </div>
                        <div className="md:flex md:flex-none"></div>
                        <div className="flex flex-1 flex-col items-center md:p-0 py-10">
                            <img className="w-10" src={emailLogo} alt="Email"/>
                            <p className="text-3xl font-semibold">Send Us an Email:</p>
                            <p className="text-lg">bottledepot@nybottledepot.com</p>
                        </div>
                    </div>
                </div>
    
            </div>
            <Footer />
        </div>
    )
}

export default Contact
